import React from "react";
import PropTypes from "prop-types";
import * as yup from "yup";
import { defaultLimitValueValidator } from "validators/licenseLimitValidators";

import { FormGroupTitle, FormSwitchField, FormTextField } from "ui/Form";
import DialogFormWithMutation from "dialogs/DialogFormWithMutation";

import {
  CREATE_LICENSE_LIMIT,
  READ_LICENSE_LIMITS_NAME,
} from "graphqlQueries/licenses";

const validation = yup.object({
  name: yup.string().required("Name is required"),
  description: yup.string(),
  default_value: defaultLimitValueValidator,
  enable: yup.boolean(),
});

const initialValues = {
  name: "",
  description: "",
  default_value: 10,
  enable: true,
};

const fieldsWithPlaceForError = ["name", "description", "default_value"];

const CreateLicenseLimitDialog = (props) => {
  return (
    <DialogFormWithMutation
      mutationQueries={CREATE_LICENSE_LIMIT}
      refetchQueries={[READ_LICENSE_LIMITS_NAME]}
      initialValues={initialValues}
      validationSchema={validation}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="New license limit"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Limit information" />
      <FormTextField name="name" label="Name" />
      <FormTextField name="default_value" label="Value" type="number" />
      <FormTextField name="description" label="Comment" />
      <FormSwitchField name="enable" label="Enabled by default" />
    </DialogFormWithMutation>
  );
};

CreateLicenseLimitDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default CreateLicenseLimitDialog;
